/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_UnlockInputs */

const en_us2_exercise_personal_strength_unlock = /** @type {(inputs: Exercise_Personal_Strength_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log a set with weight to see where you stand.`)
};

const pt_br2_exercise_personal_strength_unlock = /** @type {(inputs: Exercise_Personal_Strength_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registre uma série com carga para ver onde você está.`)
};

const es_419_exercise_personal_strength_unlock = /** @type {(inputs: Exercise_Personal_Strength_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra una serie con peso para ver dónde estás.`)
};

const pt_pt2_exercise_personal_strength_unlock = /** @type {(inputs: Exercise_Personal_Strength_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regista uma série com carga para veres onde estás.`)
};

const fr_fr2_exercise_personal_strength_unlock = /** @type {(inputs: Exercise_Personal_Strength_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistre une série avec charge pour voir où tu te situes.`)
};

const de_de2_exercise_personal_strength_unlock = /** @type {(inputs: Exercise_Personal_Strength_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trag einen Satz mit Gewicht ein, um zu sehen, wo du stehst.`)
};

const it_it2_exercise_personal_strength_unlock = /** @type {(inputs: Exercise_Personal_Strength_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra una serie con peso per vedere a che punto sei.`)
};

/**
* | output |
* | --- |
* | "Log a set with weight to see where you stand." |
*
* @param {Exercise_Personal_Strength_UnlockInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_unlock = /** @type {((inputs?: Exercise_Personal_Strength_UnlockInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_UnlockInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_unlock(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_unlock(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_unlock(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_unlock(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_unlock(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_unlock(inputs)
	return en_us2_exercise_personal_strength_unlock(inputs)
});
export { exercise_personal_strength_unlock as "exercise-personal.strength_unlock" }